<kc-switch
  class="import-switch"
  [options]="options()"
  [selectedValue]="selectedMethod()"
  [isFullWidth]="true"
  [ariaLabel]="'Select import method'"
  (selectionChange)="onSelectionChange($event)"
/>
